<template>
  <div>
    <div class="ui left labeled fluid input" v-if="saleState !== 3">
      <div class="ui basic label">
        Send your eth to
      </div>
      <input type="text" readonly v-model="tokenAddress" v-bind:style="termsAccepted ? '' : 'color:red'" id="tokenAddress">
    </div>
    <small><b>DO NOT</b> send ether from exchanges</small>
  </div>
</template>

<script>
import config from '../config'

export default {
  name: 'ethAddress',
  data() {
    return {
      tokenAddress: config.tokenAddress,
    }
  },
  computed: {
    saleState() {
      return 3
    },
    termsAccepted() {
      return this.$store.state.termsAccepted
    },
  },
}
</script>

<style scoped>
small {
  display: block;
  margin-top: 1rem;
  color: white;
  font-weight: lighter;
  font-size: 1rem;
}
.input {
  max-width: 40rem !important;
  margin: auto;
}
.label {
  font-weight: 200;
  border: none !important;
}
#tokenAddress {
  font-size: 1rem;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// EthAddress.vue?18ea726c